import { render, staticRenderFns } from "./monthlyTraining.vue?vue&type=template&id=bf91f05c&scoped=true&"
import script from "./monthlyTraining.vue?vue&type=script&lang=js&"
export * from "./monthlyTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf91f05c",
  null
  
)

export default component.exports